import React, { Component } from 'react';
import Loader from '../Loader'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteForever';
import { IconButton } from '@mui/material';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import WorkSelect from '../Work/WorkSelect'
import authStore from '../../Auth/AuthStore';
import MainStore from '../../../MainStore';
import WorkStore from '../Kanban/WorkStore';
import './link.css'

export default class LinkBoard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            links: [],
            isInLoading: false,
            isAddOpen: false,
            typeId: '9a63735b-03f7-422c-b877-3f88f3ac1dd6',
            url: '',
            linkedWorkId: ''
        };

        this.handleAdd = this.handleAdd.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleWorkSelect = this.handleWorkSelect.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.load = this.load.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
    }

    handleAdd() {
        this.setState({ isAddOpen: true, work: null });
    }

    handleClose() {
        this.setState({ isAddOpen: false });
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    handleWorkSelect(work) {
        this.setState({ work: work });
    }

    handleSave() {
        var scope = this;
        this.setState({ isInLoading: true });
        var token = localStorage.getItem("token");
        fetch('api/Work/AddLink', {
            method: 'POST',
            body: JSON.stringify({ workId: this.props.workId, typeId: this.state.typeId, comment: this.state.comment, linkedWorkId: this.state.work && this.state.work.id, Url: this.state.url }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                scope.setState({isLoading: false });
            }
            else {
                res.json().then((result) => {
                    var links = scope.state.links;
                    links.push(result);
                    scope.setState({ isAddOpen: false, isInLoading: false, links: links });
                }).catch((err) => console.log(err));
            }
        });
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.workId !== this.props.workId) {
            this.load();
        }
    }

    load() {
        if (!this.props.workId) return;
        var scope = this;
        MainStore.setMaskVisible();
        fetch('api/Work/GetLinks?workId=' + this.props.workId, {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    scope.setState({ links: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleWorkClick(workId) {
        MainStore.setMaskVisible();
        fetch('api/Work/GetWork?id=' + workId, {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    WorkStore.openWorkDialog(result);
                }).catch((err) => console.log(err));
            }
        });
    }

    handleDeleteClick(linkModel) {
        var scope = this;
        this.setState({ isInLoading: true });
        var token = localStorage.getItem("token");
        fetch('api/Work/DeleteLink', {
            method: 'POST',
            body: JSON.stringify(linkModel),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                scope.setState({ isLoading: false });
            }
            else {
                res.json().then((result) => {
                    var links = scope.state.links;
                    links.splice(links.findIndex((l) => l.id === linkModel.id), 1);
                    scope.setState({ links: links, isInLoading: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        if (this.state.isInLoading) {
            return <div><Loader /></div>
        }
        var links = this.state.links && this.state.links.map && this.state.links.map(h =>
            <div className="link-item clearfix">
                <IconButton
                    className="delete-link-button"
                    onClick={() => this.handleDeleteClick(h)}
                    size="large">
                    <DeleteIcon />
                </IconButton>
                <div className="link-type-caption">{h.type}</div>
                {(h.type === 'CRM' || h.type === 'URL') && <a href={h.number} target="_blank" rel="noopener noreferrer">{h.number}</a>}
                {(h.type !== 'CRM' && h.type !== 'URL') && <div>
                    <div className="work-link" onClick={() => { this.handleWorkClick(h.linkedWorkId) }}>{h.number}</div>
                    <div className="link-work-caption">{h.caption}</div>
                    <div className="link-work-status">{h.status}</div>
                </div>}
                <div className="link-type-comment">{h.comment}</div>
            </div>);
        if (!this.props) {
            return <div></div>
        }
        return (
            <div>
                <Dialog
                    onClose={this.handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={this.state.isAddOpen}
                    maxWidth="md"
                    className="add-link-dialog"
                    fullWidth
                >
                    <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                        Добавление ссылки
                    </DialogTitle>
                    <DialogContent dividers>
                        <Typography component={'span'}>
                            <Select
                                value={this.state.typeId}
                                onChange={this.handleChange('typeId')}
                            >
                                <MenuItem value="9a63735b-03f7-422c-b877-3f88f3ac1dd6">CRM</MenuItem>
                                <MenuItem value="8bb1bd43-9421-477d-a899-dcae3d5dbb11">URL</MenuItem>
                                <MenuItem value="e7b8c375-bbf5-4e1d-a4c3-0a2f9fc84eb0">Блокирует</MenuItem>
                                <MenuItem value="5528829e-8790-44a6-8e0b-78b7ddbb7e1d">Включает</MenuItem>
                            </Select>
                        </Typography>
                        {(this.state.typeId === "9a63735b-03f7-422c-b877-3f88f3ac1dd6" || this.state.typeId === "8bb1bd43-9421-477d-a899-dcae3d5dbb11") && <Typography component={'span'}>
                            <TextField required
                                id="standard-required"
                                label="Url"
                                fullWidth
                                margin="normal"
                                value={this.state.url}
                                onChange={this.handleChange('url')}
                            />
                        </Typography>}
                        {this.state.typeId !== "9a63735b-03f7-422c-b877-3f88f3ac1dd6" && <Typography component={'span'}>
                            <WorkSelect handleSelect={this.handleWorkSelect} />
                        </Typography>}
                        <Typography>
                            <TextField required
                                id="standard-required"
                                label="Комментарий"
                                fullWidth
                                multiline
                                rows="7"
                                margin="normal"
                                value={this.state.comment}
                                onChange={this.handleChange('comment')}
                            />
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleSave} color="primary">
                            Сохранить
                        </Button>
                    </DialogActions>
                </Dialog>
                Связи
                <IconButton variant="outlined" color="primary" onClick={this.handleAdd} size="large">
                    <AddIcon />
                </IconButton>
                <div className="link-list-wrapper">
                    {links}
                </div>
            </div>
        );
    }
}
